<template>
  <div class="oai-BookDemoStep">
    <OnboardingAiStepHeader
      :wizard-step="props.wizardStep"
      title-key-path="onboarding.ai.book_demo.title"
      title-key-name="experts"
      :title-key-accent="$t('onboarding.ai.book_demo.title_accent')"
    />

    <BookingDemo @click="onLinkClick" />

    <OnboardingAiStepActions
      icon-after="arrow-right-simple-next"
      :disable="isNavigating"
      @next="emit('next')"
    >
      <template #default>
        {{ $t('action.get_started') }}
      </template>
    </OnboardingAiStepActions>
  </div>
</template>

<script setup>
import { isUndefined } from 'lodash'
import { computed, onMounted } from 'vue'

import {
  useOnboardingAiStepContext,
  useOnboardingAiTracking
} from '@/composables/onboarding-ai-step'
import { EVENT_NAMES } from '@/tracking/amplitude-helpers'
import { IS_DEVELOPMENT } from '@root/app-modes'

import BookingDemo from '@/components/ui/onboarding/BookingDemo'
import OnboardingAiStepActions from '@/components/ui/onboarding-ai/OnboardingAiStepActions'
import OnboardingAiStepHeader from '@/components/ui/onboarding-ai/OnboardingAiStepHeader'

defineOptions({
  name: 'OnboardingAiBookDemoStep'
})

const props = defineProps({
  wizardStep: {
    type: Number,
    required: true
  }
})

const emit = defineEmits({
  next: null
})

const { logEvent } = useOnboardingAiTracking()

const stepContext = useOnboardingAiStepContext()
const isNavigating = computed(() => Boolean(stepContext?.navigating))

const TRACKING_BY_BOX_ID = {
  demo: EVENT_NAMES.ONBOARDING_BOOK_DEMO_PRODUCT_DEMO_CLICKED,
  consulting: EVENT_NAMES.ONBOARDING_BOOK_DEMO_OKR_CONSULTING_CLICKED
}

const onLinkClick = box => {
  const eventName = TRACKING_BY_BOX_ID[box.tracking]
  if (!isUndefined(eventName)) {
    logEvent(eventName)
  } else {
    if (IS_DEVELOPMENT) {
      console.error('No tracking value found for box', box)
    }
  }
}

onMounted(() => {
  logEvent(EVENT_NAMES.ONBOARDING_BOOK_DEMO_VIEWED)
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/onboarding-ai-step';

.oai-BookDemoStep {
  @extend %oai-wizard-step-shell;
}
</style>
